exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-wrap[data-v-2f019386]  .el-button{height:28px!important;border-radius:5px!important}.search-wrap[data-v-2f019386]  .el-input--small .el-input__inner{height:28px!important;line-height:28px!important}.markerTable .el-table td[data-v-2f019386],.markerTable[data-v-2f019386]  .el-table th.is-leaf{border:none!important}[data-v-2f019386] .el-pagination.is-background.el-pagination--small .btn-next,[data-v-2f019386] .el-pagination.is-background.el-pagination--small .btn-prev,[data-v-2f019386] .el-pagination.is-background.el-pagination--small .el-pager li{padding:0!important;margin:0 3px!important}", ""]);

// exports
